import { render, staticRenderFns } from "./SiteEdit.vue?vue&type=template&id=c5bcf97c&scoped=true"
import script from "./SiteEdit.vue?vue&type=script&lang=js"
export * from "./SiteEdit.vue?vue&type=script&lang=js"
import style0 from "./SiteEdit.vue?vue&type=style&index=0&id=c5bcf97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bcf97c",
  null
  
)

export default component.exports